import { Input } from '@payaca/ambrosia';
import { CustomFieldHelperType } from '@payaca/custom-fields';
import { FC } from 'react';
import { FieldProps } from './fieldInputTypes';

export const UrlFieldInput: FC<FieldProps<'url'>> = (props) => {
  const { value, onChange } = props;

  const handleOnChange = (
    v: Partial<CustomFieldHelperType['url']['value']>
  ) => {
    if (v && (v.title?.length || v.url?.length)) {
      onChange(v as CustomFieldHelperType['url']['value']);
    } else {
      onChange(null);
    }
  };

  return (
    <div className="space-y-2">
      <Input
        placeholder="Title"
        value={value?.title ?? ''}
        onChange={(v: string) => {
          handleOnChange({
            ...(value || { url: '' }),
            title: v.length === 0 ? undefined : v,
          });
        }}
      />
      <Input
        placeholder="https://"
        value={value?.url ?? ''}
        onChange={(v: string) => {
          handleOnChange({
            ...(value || { url: '' }),
            url: v.length === 0 ? undefined : v,
          });
        }}
      />
    </div>
  );
};
